/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// import throttle from 'lodash.throttle';
import dateFormat from 'date-fns/format';
import Link from 'components/Link';
import makeRequest from '../../../utils/makeRequest';
import s from './MatchInfoCard.scss';

class MatchInfoCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      team1: '',
      team2: '',
      event_sub_status: '',
    };
    this.refreshTimer = '';
  }
  componentWillMount() {
    if (this.props.data) {
      const { isUpcomingMatch, isMatchEnded } = this.props;
      let { isLiveMatch } = this.props;
      isLiveMatch = isLiveMatch || true;
      if (isMatchEnded || isUpcomingMatch) {
        isLiveMatch = false;
      }
      const { participants, event_sub_status } = this.props.data;
      if (participants && participants.length > 0) {
        participants.sort((teama, teamb) => {
          const fa = teama && teama.firstup ? teama.firstup.toLowerCase() : '';
          const fb = teamb && teamb.firstup ? teamb.firstup.toLowerCase() : '';

          if (fa > fb) {
            return -1;
          }
          if (fa < fb) {
            return 1;
          }
          return 0;
        });
      }
      this.setState({
        team1: participants && participants.length > 0 ? participants[0] : '',
        team2: participants && participants.length > 1 ? participants[1] : '',
        event_sub_status,
      });
      if (isLiveMatch) {
        this.refreshLiveMatchData(participants[0], participants[1]);
        this.refreshTimer = setInterval(() => {
          // setIsLoading(true);
          this.refreshLiveMatchData(participants[0], participants[1]);
        }, 30000);
      }
    }
  }
  componentWillUnmount() {
    clearInterval(this.refreshTimer);
  }
  processVenueName = venueName => {
    if (
      venueName &&
      typeof venueName === 'string' &&
      venueName.toLowerCase() !== 'to be confirmed'
    ) {
      const venueArr = venueName.split(',');
      if (venueArr && Array.isArray(venueArr) && venueArr.length > 0) {
        const cityName = venueArr[venueArr.length - 1];
        return cityName;
      }
    }
    return venueName;
  };
  refreshLiveMatchData = (team1, team2) => {
    if (this.props.data) {
      const { matchfile } = this.props.data;
      const teamaid = team1?.id;
      const teambid = team2?.id;
      let teamainngscore = [];
      let teambinngscore = [];
      makeRequest
        .get(
          `https://toicri.timesofindia.indiatimes.com/jsons/${matchfile}.json`,
          { isMobile: this.props.isWapView },
          'skipfeedengine',
        )
        // eslint-disable-next-line consistent-return
        .then(result => {
          if (result?.data) {
            const matchData = result?.data;
            const matchType = matchData?.Matchdetail?.Match?.Type;
            const isTest = matchType && matchType.toLowerCase() === 'test';
            const matchEquation = matchData?.Matchequation?.Equation;
            if (
              matchData?.Innings &&
              Array.isArray(matchData?.Innings) &&
              matchData?.Innings.length > 0
            ) {
              const score = matchData?.Innings.map(match => {
                if (match?.Battingteam === teamaid) {
                  if (isTest) {
                    teamainngscore.push(
                      match?.Total && match?.Wickets
                        ? `${match?.Total}/${match?.Wickets}`
                        : match?.Total,
                    );
                  } else {
                    teamainngscore = `${match?.Total}/${match?.Wickets} (${
                      match.Overs
                    } ov)`;
                  }
                }
                if (match?.Battingteam === teambid) {
                  if (isTest) {
                    teambinngscore.push(
                      match?.Total && match?.Wickets
                        ? `${match?.Total}/${match?.Wickets}`
                        : match?.Total,
                    );
                  } else {
                    teambinngscore = `${match?.Total}/${match?.Wickets} (${
                      match.Overs
                    } ov)`;
                  }
                }
                return match;
              });
              if (isTest) {
                team1.inngscore = teamainngscore;
              } else {
                team1.value = teamainngscore;
              }
              if (isTest) {
                team2.inngscore = teambinngscore;
              } else {
                team2.value = teambinngscore;
              }
              this.setState({ team1, team2, event_sub_status: matchEquation });
              return score;
            }
          }
        })
        .catch(() => {
          // console.log(error);
        });
    }
  };
  ical_download = (startdate, enddate, summary, desc, location, event) => {
    event.preventDefault();
    const datestart = dateFormat(new Date(startdate), 'YYYYMMDTHHmmss');
    const dateende = dateFormat(new Date(enddate), 'YYYYMMDTHHmmss');
    //name of event in iCal
    //this.eventName = summary;

    //name of file to download as
    this.fileName = `${summary}.ics`;
    const now = new Date();
    const ics_lines = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:timesofindia.indiatimes.com',
      'METHOD:PUBLISH',
      'BEGIN:VEVENT',
      `DTSTAMP:${this.ical_isofix(now)}`,
      'STATUS:CONFIRMED',
      `UID:event-${now.getTime()}timesofindia.indiatimes.com`,
      `DTSTART:${datestart}`,
      `DTEND:${dateende}`,
      `SUMMARY:${summary}`,
      `DESCRIPTION:${desc}`,
      `LOCATION:${location}`,
      'BEGIN:VALARM',
      'TRIGGER:-PT15M',
      'ACTION:DISPLAY',
      'END:VALARM',
      'TRANSP:OPAQUE',
      //"LAST-MODIFIED:" + this._isofix(now),
      'SEQUENCE:0',
      'PRIORITY:3',
      'END:VEVENT',
      'END:VCALENDAR',
    ];

    const dlurl = `data:text/calendar;base64,${btoa(ics_lines.join('\r\n'))}`;
    try {
      this.ical_save(dlurl);
    } catch (e) {
      //console.log(e);
    }
  };

  ////iso date for ical formats
  ical_isofix = d => {
    const offset = `0${new Date().getTimezoneOffset() / 60}`.slice(-2);

    if (typeof d === 'string') {
      return `${d.replace(/\-/g, '')}T${offset}0000Z`;
    }
    return `${d.getFullYear() +
      this.ical_zp(d.getMonth() + 1) +
      this.ical_zp(d.getDate())}T${this.ical_zp(d.getHours())}0000Z`;
  };

  ical_zp = dp => `0${dp}`.slice(-2);
  ical_save = fileURL => {
    if (!window.ActiveXObject) {
      const save = document.createElement('a');
      save.href = fileURL;
      save.target = '_blank';
      save.download = this.fileName || 'unknown';

      const evt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: false,
      });
      save.dispatchEvent(evt);

      (window.URL || window.webkitURL).revokeObjectURL(save.href);
    } else if (!!window.ActiveXObject && document.execCommand) {
      // for IE < 11
      const _window = window.open(fileURL, '_blank');
      _window.document.close();
      _window.document.execCommand('SaveAs', true, this.fileName || fileURL);
      _window.close();
    }
  };

  getScoreOver = (value, event_format, team) => {
    if (value && typeof value === 'string') {
      if (event_format && event_format.toLowerCase() !== 'test') {
        value = value.replace(/[()]/g, '');
        const ballScoreArr = value.split(' ');
        return ballScoreArr;
      }
      const scoreArr = value.split(' & ');
      team.inngscore = [];
      if (scoreArr && Array.isArray(scoreArr) && scoreArr.length > 0) {
        scoreArr.forEach(inngs => {
          if (inngs && typeof inngs === 'string') {
            const inngArr = inngs.split(' ');
            if (inngArr && Array.isArray(inngArr) && inngArr.length > 0) {
              team.inngscore.push(inngArr[0]);
            }
          }
        });
      }
    }
    return '';
  };

  landToMatchCenterPage = cardurl => {
    if (cardurl) {
      window.location.href = cardurl;
    }
  };

  render() {
    let Renderedcomponent;
    if (this.props.data) {
      const { isUpcomingMatch, isMatchEnded, isLanding } = this.props;
      let { isLiveMatch } = this.props;
      isLiveMatch = isLiveMatch || true;
      if (isMatchEnded || isUpcomingMatch) {
        isLiveMatch = false;
      }
      const inningsMappings = ['1st', '2nd', '3rd', '4th'];
      const cardHeaderClassname = classnames({
        [`${s.MatchInfoCardWrapper}`]: true,
        [`${s.isUpcomingMatchCard}`]: isUpcomingMatch,
        [`${s.liveMatchCard}`]: isLiveMatch,
        [`${s.endedMatchCard}`]: isMatchEnded,
        [`${s.LandingPageCard}`]: isLanding,
        [`${s.oldCardWrapper}`]: !isLanding,
      });
      const { seriesname } = this.props;
      const {
        start_date,
        venue_name,
        event_name,
        liveblogurl,
        short_event_status,
        end_date,
        cardurl,
        venueUrl,
        participants,
        event_format,
      } = this.props.data;
      const team1 = this?.state?.team1
        ? this.state.team1
        : participants && participants.length > 0 ? participants[0] : '';
      const team2 = this?.state?.team2
        ? this.state.team2
        : participants && participants.length > 1 ? participants[1] : '';
      const ballOver1 =
        team1 && team1.value
          ? this.getScoreOver(team1.value, event_format, team1)
          : '';
      const ballOver2 =
        team2 && team2.value
          ? this.getScoreOver(team2.value, event_format, team2)
          : '';
      const country1Classname = classnames({
        [`${s.country_score}`]: true,
        [`${s.playing}`]: isMatchEnded || (ballOver1 && ballOver1.length > 0),
      });
      const team1inngscoreAvailable =
        team1 &&
        team1.inngscore &&
        Array.isArray(team1.inngscore) &&
        team1.inngscore.length > 0;
      const team2inngscoreAvailable =
        team2 &&
        team2.inngscore &&
        Array.isArray(team2.inngscore) &&
        team2.inngscore.length > 0;
      const country2Classname = classnames({
        [`${s.country_score}`]: true,
        [`${s.right_side}`]: true,
        [`${s.playing}`]: isMatchEnded || (ballOver2 && ballOver2.length > 0),
      });
      if (!isLanding) {
        Renderedcomponent = (
          <a className={cardHeaderClassname} href={cardurl}>
            <div className={s.top_header}>
              <div>{`${dateFormat(
                new Date(start_date),
                'D MMM, YYYY hh:mm aa',
              )}`}</div>

              <div className={s.venue_name}>
                <div className={s.marquee}>
                  <p>
                    <span>{this.processVenueName(venue_name)}</span>
                  </p>
                </div>
              </div>
            </div>
            <div className={s.matchinnerinfo}>
              <div className={s.match_count}>{event_name}</div>
              <div className={s.match_score}>
                <div className={country1Classname}>
                  <div className={s.country_name}>
                    {team1 && team1.short_name}
                  </div>
                  <div className={s.flag_score}>
                    <div className={`${s.flag} ${s.teamBg}`}>
                      {team1 &&
                        team1.short_name &&
                        team1.short_name !== 'TBC' && (
                          <i className={`${s.icon} ${s[team1?.short_name]}`} />
                        )}
                    </div>
                    {!isUpcomingMatch &&
                      !team1inngscoreAvailable && (
                        <div className={s.score_details}>
                          <div className={s.score}>
                            {ballOver1 &&
                              Array.isArray(ballOver1) &&
                              ballOver1.length > 0 &&
                              ballOver1[0]}
                          </div>
                          <div className={s.overs}>
                            {ballOver1 &&
                            Array.isArray(ballOver1) &&
                            ballOver1.length > 1 &&
                            ballOver1[1] &&
                            !ballOver1[1].includes('-')
                              ? `${ballOver1[1]} ov`
                              : ballOver1[1]}
                          </div>
                        </div>
                      )}
                    {!isUpcomingMatch &&
                      team1inngscoreAvailable && (
                        <div className={`${s.innings_wrap}`}>
                          {team1.inngscore.map((inngs, index) => (
                            <div className={s.innings_score}>
                              <span>{inningsMappings[index]} Inngs</span>
                              <span>{inngs}</span>
                            </div>
                          ))}
                          {!isMatchEnded &&
                            team1 &&
                            team1?.highlight && <i className={s.battingteam} />}
                        </div>
                      )}
                  </div>
                </div>
                {isLiveMatch && <div className={s.live_tag}>Live</div>}
                {!isLiveMatch && <div className={s.vs_tag} />}

                <div className={country2Classname}>
                  <div className={s.country_name}>
                    {team2 && team2.short_name}
                  </div>
                  <div className={s.flag_score}>
                    <div className={s.flag}>
                      {team2 &&
                        team2.short_name &&
                        team2.short_name !== 'TBC' && (
                          <i className={`${s.icon} ${s[team2?.short_name]}`} />
                        )}
                    </div>
                    {!isUpcomingMatch &&
                      !team2inngscoreAvailable && (
                        <div className={s.score_details}>
                          <div className={s.score}>
                            {ballOver2 &&
                              Array.isArray(ballOver2) &&
                              ballOver2.length > 0 &&
                              ballOver2[0]}
                          </div>
                          <div className={s.overs}>
                            {ballOver2 &&
                            Array.isArray(ballOver2) &&
                            ballOver2.length > 1 &&
                            ballOver2[1] &&
                            !ballOver2[1].includes('-')
                              ? `${ballOver2[1]} ov`
                              : ballOver2[1]}
                          </div>
                        </div>
                      )}
                    {!isUpcomingMatch &&
                      team2inngscoreAvailable && (
                        <div className={`${s.innings_wrap}`}>
                          {team2.inngscore.map((inngs, index) => (
                            <div className={s.innings_score}>
                              <span>{inningsMappings[index]} Inngs</span>
                              <span>{inngs}</span>
                            </div>
                          ))}
                          {!isMatchEnded &&
                            team2 &&
                            team2?.highlight && <i className={s.battingteam} />}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
            <div className={s.runs_cta}>
              <div className={s.run_count}>
                {/* IRE needs <span>222</span> runs in <span>20.0</span> overs */}
                {!isUpcomingMatch &&
                  short_event_status !== '' &&
                  short_event_status}
                {!isUpcomingMatch &&
                  short_event_status === '' &&
                  this.state.event_sub_status}
              </div>
              {isLiveMatch &&
                liveblogurl && (
                  <div className={s.cta}>
                    <Link
                      to={liveblogurl}
                      target="_blank"
                      className={s.view_score}
                    >
                      View Scorecard
                    </Link>
                    {/* <Link className={s.notify}>View Scorecard</Link> */}
                  </div>
                )}
              {isUpcomingMatch && (
                <span
                  className={s.notify}
                  onClick={e =>
                    this.ical_download(
                      start_date,
                      end_date,
                      `${seriesname} ${event_name} ${team1?.short_name} vs ${
                        team2?.short_name
                      }`,
                      this.state.event_sub_status,
                      venue_name,
                      e,
                    )
                  }
                >
                  Remind me<i />
                </span>
              )}
            </div>
          </a>
        );
      }
      if (isLanding) {
        Renderedcomponent = (
          <div
            className={cardHeaderClassname}
            onClick={() => this.landToMatchCenterPage(cardurl)}
          >
            <div className={s.matchinnerinfo}>
              <div title={event_name} className={s.match_count}>
                {event_name}
              </div>
              <div className={s.match_score}>
                <div className={country1Classname}>
                  <div className={s.country_name}>
                    {team1 && team1.short_name}
                  </div>
                  <div className={s.flag_score}>
                    <div>
                      {team1 &&
                        team1.winingteam && <i className={s.winningteam} />}
                    </div>
                    <div className={s.flag}>
                      {team1 &&
                        team1.short_name &&
                        team1.short_name !== 'TBC' && (
                          <i className={`${s.icon} ${s[team1?.short_name]}`} />
                        )}
                    </div>
                    {!isUpcomingMatch &&
                      !team1inngscoreAvailable && (
                        <div className={s.score_details}>
                          <div className={s.score}>
                            {ballOver1 &&
                              Array.isArray(ballOver1) &&
                              ballOver1.length > 0 &&
                              ballOver1[0]}
                          </div>
                          <div className={s.overs}>
                            {ballOver1 &&
                            Array.isArray(ballOver1) &&
                            ballOver1.length > 1 &&
                            ballOver1[1] &&
                            !ballOver1[1].includes('-')
                              ? `${ballOver1[1]} ov`
                              : ballOver1[1]}
                          </div>
                        </div>
                      )}
                    {!isUpcomingMatch &&
                      team1inngscoreAvailable && (
                        <div className={s.innings_wrap}>
                          {team1.inngscore.map((inngs, index) => (
                            <div className={s.innings_score}>
                              <span>{inningsMappings[index]} Inngs</span>
                              <span>{inngs}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    <div>
                      {!isMatchEnded &&
                        team1 &&
                        team1.battingteam && <i className={s.battingteam} />}
                    </div>
                  </div>
                </div>
                <div className={s.status_date_info}>
                  {isLiveMatch && <div className={s.live_tag}>Live</div>}
                  {/* {!isLiveMatch && isMatchEnded && <div className={s.vs_tag} />} */}
                  {!isLiveMatch &&
                    isMatchEnded && (
                      <div className={s.completed_tag}>Completed</div>
                    )}
                  {isUpcomingMatch && (
                    <div className={s.upcoming_tag}>Upcoming</div>
                  )}
                  {isUpcomingMatch && (
                    <div className={s.date_time}>{`${dateFormat(
                      new Date(start_date),
                      'D MMM, hh:mm aa',
                    )} IST`}</div>
                  )}
                </div>
                <div className={country2Classname}>
                  <div className={s.country_name}>
                    {team2 && team2.short_name}
                  </div>
                  <div className={s.flag_score}>
                    <div>
                      {!isMatchEnded &&
                        team2 &&
                        team2.battingteam && <i className={s.battingteam} />}
                    </div>
                    <div className={s.flag}>
                      {team2 &&
                        team2.short_name &&
                        team2.short_name !== 'TBC' && (
                          <i className={`${s.icon} ${s[team2?.short_name]}`} />
                        )}
                    </div>
                    {!isUpcomingMatch &&
                      !team2inngscoreAvailable && (
                        <div className={s.score_details}>
                          <div className={s.score}>
                            {ballOver2 &&
                              Array.isArray(ballOver2) &&
                              ballOver2.length > 0 &&
                              ballOver2[0]}
                          </div>
                          <div className={s.overs}>
                            {ballOver2 &&
                            Array.isArray(ballOver2) &&
                            ballOver2.length > 1 &&
                            ballOver2[1] &&
                            !ballOver2[1].includes('-')
                              ? `${ballOver2[1]} ov`
                              : ballOver2[1]}
                          </div>
                        </div>
                      )}
                    {!isUpcomingMatch &&
                      team2inngscoreAvailable && (
                        <div className={s.innings_wrap}>
                          {team2.inngscore.map((inngs, index) => (
                            <div className={s.innings_score}>
                              <span>{inningsMappings[index]} Inngs</span>
                              <span>{inngs}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    <div>
                      {team2 &&
                        team2.winingteam && <i className={s.winningteam} />}
                    </div>
                  </div>
                </div>
              </div>
              {!isUpcomingMatch && (
                <div className={s.venue_name}>
                  {/* IRE needs <span>222</span> runs in <span>20.0</span> overs */}
                  {!isUpcomingMatch && this.state.event_sub_status}
                </div>
              )}
              {isUpcomingMatch && (
                <a className={s.venue_name} href={venueUrl}>
                  {venue_name}
                </a>
              )}
              {(isLiveMatch || isMatchEnded) && (
                <a className={s.match_cta} href={cardurl}>
                  View Scorecard
                </a>
              )}
              {isUpcomingMatch && (
                <a
                  className={`${s.match_cta} ${s.match_center_cta}`}
                  href={cardurl}
                >
                  Match Center
                </a>
              )}
            </div>
          </div>
        );
      }
    }
    return Renderedcomponent;
  }
}

MatchInfoCard.propTypes = {
  isLiveMatch: PropTypes.bool,
  isUpcomingMatch: PropTypes.bool,
  isMatchEnded: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.shape({})),
  seriesname: PropTypes.string,
  isLanding: PropTypes.bool,
  // setFallback: PropTypes.func,
};

MatchInfoCard.defaultProps = {
  isUpcomingMatch: false,
  isLiveMatch: false,
  isMatchEnded: false,
  data: {},
  seriesname: '',
  isLanding: false,
};

export default MatchInfoCard;
